
































import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { FileHelper as _file } from '@/helper/file.helper';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { vehicleInventoryService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        Calendar: () => import('@/components/common/app.calendar.vue'),
        Datepicker: () => import('@/components/common/app.datepicker.vue'),
    },
})
export default class RfidReportPage extends Base {
    public rfidTagsList: any[] = [];
    public headers: VHeaders[] = [];
    public loading: boolean = false;
    public isPageDestroyed: boolean = false;
    public actions: any[] = [];
    public pagination = new PaginationModel('udpdatedAt', true);
    public params: any = {
        startDate: '',
        endDate: '',
    };
    // public $moment: any;

    public storeId: number = 0;
    public resetFilter: boolean = false;
    public async mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'rfidreport');
        this.storeId = this.userSession.storeId;
        this.setActions();
        this.setHeaders();
        await this.getRfidReport();
    }
    public setActions() {
        this.actions = [{}];
    }
    public resetFilters() {
        this.params.endDate = '';
        this.params.startDate = '';
        this.resetFilter = !this.resetFilter;
        this.setDateParms([]);
    }
    public created(): void {
        this.params.startDate = this.subtractDaysFromPresent(6);
        this.params.endDate = this.presentDate();
    }
    public setDateParms(dates: any) {
        if (dates.length > 0) {
            if (dates[0]) {
                this.params.startDate = dates[0];
            } else {
                this.params.startDate = '';
            }
            if (dates[1]) {
                this.params.endDate = dates[1];
            } else {
                this.params.endDate = '';
            }
        }
    }

    public setHeaders() {
        this.headers = [
            {
                text: 'Stock Number',
                align: 'left',
                value: 'stockNumber',
                sortable: true,
            },
            {
                text: 'Make',
                align: 'left',
                value: 'make',
                sortable: false,
            }, {
                text: 'Model',
                align: 'left',
                value: 'model',
                sortable: false,
            }, {
                text: 'Model Year',
                align: 'left',
                value: 'modelYear',
                sortable: false,
            }, {
                text: 'Vin',
                align: 'left',
                value: 'vin',
                sortable: false,
            },
            {
                text: 'Rfid Tag',
                align: 'left',
                value: 'rfidTag',
                sortable: false,
            },
            {
                text: 'Rfid Status',
                align: 'left',
                value: 'rfidTag',
                sortable: false,
                filters: [
                    (val) => {
                        return val && val != "" && val != 'N/A' ? 'Scanned' : 'Not Scanned';
                    },
                ],
            },
            {
                text: 'Last Scan At',
                align: 'left',
                value: 'updatedAt',
                sortable: true,
                fieldType: 'template',
                template: (item) => {
                    var date = item.updatedAt
                        ? this.$moment(item.updatedAt).format('MMM DD, YYYY hh:mm:ss A')
                        : 'N/A';
                    return `<span>${date}</span>`;
                },
            },

        ];


    }

    public beforeDestroy(): void {
        this.isPageDestroyed = true;
    }
    public async searchVehicle() {
        const queryStringObj = Object.assign({}, this.pagination) as any;
        queryStringObj.startDate = this.params.startDate;
        queryStringObj.endDate = this.params.endDate;
        Utils.validateAndUpdateRoute(queryStringObj);

        if (this.params.startDate == '') {
            this.showAlert(false, 'Please select start Date');
            return;
        }
        if (this.params.endDate == '') {
            this.showAlert(false, 'Please select end Date');
            return;
        }
        await this.getRfidReport();
    }
    public async getRfidReport(): Promise<void> {
        try {
            this.loading = true;
            this.rfidTagsList = await vehicleInventoryService.getRfidReport(this.params.startDate, this.params.endDate, this.storeId);
            this.pagination.totalItems = this.rfidTagsList.length;

            const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
            if (pagination) {
                this.pagination = pagination;
                this.updatePaging(this.pagination);
            }
        } finally {
            this.loading = false;
        }
    }
    public updatePaging(paging: any): void {
        this.pagination = paging;
        const queryStringObj = Object.assign({}, this.pagination);
        Utils.validateAndUpdateRoute(queryStringObj);
    }
}
